// also see src/app/routing/app-route-query-params.ts

export const OWCC_QUERY_PARAM = {
  SALES_TOUCH_SOURCE: 'source',
  SALES_TOUCH_ENVIRONMENT: 'environment',
  CARL_LABEL: 'carlLabel',
  FORMATTING_TAG: 'formattingTag',
  AB_TESTING: 'ab',
  FCIS_ENVIRONMENT: 'fcisEnvironment',
  VEHICLE_ID: 'vehicleId',
  // used to check whether B2O modal should be instantly opened when entering via summary page
  DIRECT_SALES: 'directSales'
};
